import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import UltimatePagination from 'react-ultimate-pagination-bootstrap-4';

import { get } from 'helpers/api';
import taskApi from 'components/tasks/api';
import TaskList from 'components/tasks/task_list';
import LoadingSpinner from 'components/loading_spinner';

import './associated_tasks.scss';

export default class AssociatedTasks extends React.Component {
  static propTypes = {
    availableDatabases: PropTypes.array.isRequired,
    databaseMembers: PropTypes.array.isRequired,
    isItemSpaceActive: PropTypes.bool,
    isMobile: PropTypes.bool,
    pageSize: PropTypes.number,
    paths: PropTypes.shape({
      tasks: PropTypes.string.isRequired
    }).isRequired,
    onTaskComplete: PropTypes.func
  };

  static defaultProps = {
    pageSize: 10,
    isItemSpaceActive: false,
    isMobile: false
  };

  componentRef = React.createRef();

  state = {
    loading: true,
    currentPage: 1,
    totalPages: 1,
    tasks: [],
    totalTaskCount: 0
  };

  componentDidMount() {
    this.loadTasks();
  }

  loadTasks = (page = 1) => {
    const { pageSize, paths } = this.props;
    const params = {
      page,
      pageSize
    };

    this.setState({ loading: true });
    get(paths.tasks, { params })
      .then(({ meta, tasks }) => {
        this.setState({
          error: false,
          loading: false,
          currentPage: meta.page,
          totalTaskCount: meta.totalTasks,
          totalPages: Math.ceil(meta.totalTasks / pageSize),
          tasks
        });
      })
      .catch(() => {
        this.setState({ error: 'An error occurred when loading tasks', loading: false });
      });
  };

  loadMoreTasks = () => this.loadTasks(this.state.page + 1);

  onPageChange = page => this.loadTasks(page);

  completeTask = (taskData) => {
    const updatedTask = { ...taskData, completed: true };
    return taskApi.updateTask(updatedTask).then(() => {
      const { onTaskComplete } = this.props;
      this.reloadCurrentPage();
      this.reloadActivities();
      if (onTaskComplete) onTaskComplete(updatedTask);
    });
  };

  reloadCurrentPage() {
    const { pageSize } = this.props;
    const { totalTaskCount, currentPage } = this.state;
    const totalPages = Math.ceil((totalTaskCount - 1) / pageSize);
    const newCurrentPage = currentPage <= totalPages ? currentPage : totalPages;
    this.loadTasks(newCurrentPage);
  }

  reloadActivities() {
    if (!window.buildout) return;
    window.buildout.refreshActivities && window.buildout.refreshActivities();
  }

  removeTask = (taskData) => {
    return taskApi.removeTask(taskData).then(() => {
      this.reloadCurrentPage();
    });
  };

  updateTask = (task, onSuccess, onError) => {
    taskApi.updateTask(task, true).then((response) => {
      this.loadTasks(this.state.currentPage);
      if (onSuccess)  onSuccess(response);
    }).catch((errors) => {
      if (onError)  onError(errors);
    });
  }

  render() {
    const { isMobile } = this.props;
    return (
      <div className="js-associated-tasks" ref={this.componentRef}>
        {!isMobile && this.renderHeader()}
        {this.renderTasks()}
        {this.renderPagination()}
      </div>
    );
  }

  renderHeader() {
    const { loading, totalTaskCount } = this.state;
    const countElement = loading ? null : <span className="small text-muted">- {totalTaskCount} open tasks</span>;
    return (
      <h6 className="mt-4 mb-3" name="tasks-header">Tasks {countElement}</h6>
    );
  }

  renderTasks() {
    const { availableDatabases, databaseMembers, isMobile, isItemSpaceActive } = this.props;
    const tableClassNames = classNames('table table-condensed contacts-tasks', {
      'table-items-space': isItemSpaceActive
    });
    const { loading, tasks } = this.state;
    if (loading) return <LoadingSpinner />;
    return (
      <table className={tableClassNames} name="tasks-list-view">
        <tbody>
          <TaskList
            availableDatabases={availableDatabases}
            databaseMembers={databaseMembers}
            hideActions
            hideAssociations
            hideItemActions={isMobile}
            multipleProjectsInTask={true}
            newTaskFormStyling={isMobile}
            tasks={tasks}
            onDeleteTask={this.removeTask}
            onLoadMoreTasks={this.loadMoreTasks}
            onToggleTaskState={this.completeTask}
            onUpdateTask={this.updateTask}
          />
        </tbody>
      </table>
    );
  }

  renderPagination() {
    const { pageSize } = this.props;
    const { currentPage, totalPages, totalTaskCount } = this.state;
    if (totalTaskCount > pageSize) {
      return (
        <div className="text-center">
          <UltimatePagination
            currentPage={currentPage}
            totalPages={totalPages}
            onChange={this.onPageChange}
          />
        </div>
      );
    }
  }
}
